module.exports = __webpack_public_path__ + "static/media/pRoberts.5c70a286.jpeg";